import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import CategoriesSection from "./components/CategoriesSection";
import MarketplaceSection from "./components/MarketplaceSection";
import AboutSection from "./components/AboutSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import MenuPage from "./pages/MenuPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import CustomerAuthPage from "./pages/CustomerAuthPage";
import CustomerOrdersPage from "./pages/CustomerOrdersPage";
import DriverLoginPage from "./pages/DriverLoginPage";
import DriverSignupPage from "./pages/DriverSignupPage";
import DriverAgreementPage from "./pages/DriverAgreementPage";
import DriverDashboardPage from "./pages/DriverDashboardPage";
import { Toaster } from "./components/ui/toaster";
import { CartProvider } from "./context/CartContext";
import { ProductProvider } from "./context/ProductContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { DriverAuthProvider } from "./context/DriverAuthContext";
import DocumentTitle from "./components/DocumentTitle";
import AgeVerification from "./components/AgeVerification";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <CategoriesSection />
      <MarketplaceSection />
      <AboutSection />
      <FAQSection />
    </div>
  );
};

function App() {
  return (
    <CustomerAuthProvider>
      <DriverAuthProvider>
      <ProductProvider>
      <CartProvider>
        <div className="App">
          <BrowserRouter>
            <DocumentTitle />
            <AgeVerification />
            <Routes>
              {/* Customer Routes */}
              <Route path="/" element={<><Header /><Home /><Footer /></>} />
              <Route path="/menu" element={<><Header /><MenuPage /><Footer /></>} />
              <Route path="/checkout" element={<><Header /><CheckoutPage /><Footer /></>} />
              <Route path="/order-confirmation" element={<><Header /><OrderConfirmationPage /><Footer /></>} />
              
              {/* Customer Auth & Account */}
              <Route path="/customer/login" element={<CustomerAuthPage />} />
              <Route path="/customer/orders" element={<CustomerOrdersPage />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />

              {/* Driver Routes */}
              <Route path="/driver/login" element={<DriverLoginPage />} />
              <Route path="/driver/signup" element={<DriverSignupPage />} />
              <Route path="/driver/agreement" element={<DriverAgreementPage />} />
              <Route path="/driver/dashboard" element={<DriverDashboardPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </CartProvider>
      </ProductProvider>
      </DriverAuthProvider>
    </CustomerAuthProvider>
  );
}

export default App;
